import { I18nTypes, TermsOfUseStatus } from '@/App/types';

export interface ErrorState {
  id: I18nTypes;
}

export interface PresentationModeState {
  enabled: boolean;
}

export interface UiState {
  showLoader?: boolean;
  showTermsOfUse: boolean;
  showPrivacyPolicy: boolean;
  showCookieSettings: boolean;
  termsOfUseStatus: TermsOfUseStatus;
  showError: boolean;
  error: ErrorState | null;
  showAboutUs: boolean;
  showConsultations: boolean;
  videoCarouselAutoPlay: boolean;
  presentationMode: PresentationModeState;
}

export const initialState: UiState = {
  showLoader: false,
  showTermsOfUse: false,
  showPrivacyPolicy: false,
  showCookieSettings: false,
  termsOfUseStatus: TermsOfUseStatus.UNKNOWN,
  showError: false,
  error: null,
  showAboutUs: false,
  showConsultations: false,
  videoCarouselAutoPlay: true,
  presentationMode: {
    enabled: false,
  },
};
